import React from "react"
import { VerNotificacoesFornecedorContextProvider } from "./context/VerNotificacoesFornecedorContextProvider"
import { VerNotificacoesFornecedor } from "./VerNotificacoesFornecedor"

export function Index() {
    return (
        <VerNotificacoesFornecedorContextProvider>
            <VerNotificacoesFornecedor />
        </VerNotificacoesFornecedorContextProvider>
    )
}
